"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Service
 * Provides OIDC and Security endpoints as well as CRUD operations for SAVE and E-Verify Users and Points of Contact.
 *
 * The version of the OpenAPI document: 3.0.32
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 * no description
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * check if logonId is between 8-12 characters, strictly alphanumeric, and doesn\'t already exist
     */
    UserApi.prototype.checkNewLogonIdRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.logonId === null || requestParameters.logonId === undefined) {
                            throw new runtime.RequiredError('logonId', 'Required parameter requestParameters.logonId was null or undefined when calling checkNewLogonId.');
                        }
                        queryParameters = {};
                        if (requestParameters.logonId !== undefined) {
                            queryParameters['logonId'] = requestParameters.logonId;
                        }
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/check-new-logonid",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.IsNewLogonIdAcceptableFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * check if logonId is between 8-12 characters, strictly alphanumeric, and doesn\'t already exist
     */
    UserApi.prototype.checkNewLogonId = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkNewLogonIdRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * To be called only from the vis-registration service. Creates a new user with existing profile, accountId, and credential information. The app query parameter is required. A user with the REGISTRATION role is allowed to perform calls to backend services needed for on-boarding accounts/agencies.
     * Creates a User with a role of REGISTRATION
     */
    UserApi.prototype.createRegistrationUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createRegistrationUserBody === null || requestParameters.createRegistrationUserBody === undefined) {
                            throw new runtime.RequiredError('createRegistrationUserBody', 'Required parameter requestParameters.createRegistrationUserBody was null or undefined when calling createRegistrationUser.');
                        }
                        queryParameters = {};
                        if (requestParameters.app !== undefined) {
                            queryParameters['app'] = requestParameters.app;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/registration",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CreateRegistrationUserBodyToJSON(requestParameters.createRegistrationUserBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * To be called only from the vis-registration service. Creates a new user with existing profile, accountId, and credential information. The app query parameter is required. A user with the REGISTRATION role is allowed to perform calls to backend services needed for on-boarding accounts/agencies.
     * Creates a User with a role of REGISTRATION
     */
    UserApi.prototype.createRegistrationUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRegistrationUserRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new user with the given parameters. The \'app\' value is required. Only a single value is allowed in the roles array. In addition, values of WEB_SERVICE, UNKNOWN, REGISTRATION and EV_STAR are not allowed. >  Validation Error Codes:   * `GENERAL_VALIDATION_ERROR` > System Error Codes:   * `MESSAGING_SEND_FAILED`
     * Creates a User
     */
    UserApi.prototype.createUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createUserBody === null || requestParameters.createUserBody === undefined) {
                            throw new runtime.RequiredError('createUserBody', 'Required parameter requestParameters.createUserBody was null or undefined when calling createUser.');
                        }
                        queryParameters = {};
                        if (requestParameters.app !== undefined) {
                            queryParameters['app'] = requestParameters.app;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CreateUserBodyToJSON(requestParameters.createUserBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new user with the given parameters. The \'app\' value is required. Only a single value is allowed in the roles array. In addition, values of WEB_SERVICE, UNKNOWN, REGISTRATION and EV_STAR are not allowed. >  Validation Error Codes:   * `GENERAL_VALIDATION_ERROR` > System Error Codes:   * `MESSAGING_SEND_FAILED`
     * Creates a User
     */
    UserApi.prototype.createUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createUserRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the legacy User record for provided SSA user information, creating that record if necessary
     * Get an SSA user
     */
    UserApi.prototype.getSsaUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.ssaUserRequest === null || requestParameters.ssaUserRequest === undefined) {
                            throw new runtime.RequiredError('ssaUserRequest', 'Required parameter requestParameters.ssaUserRequest was null or undefined when calling getSsaUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/ssa",
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.SsaUserRequestToJSON(requestParameters.ssaUserRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the legacy User record for provided SSA user information, creating that record if necessary
     * Get an SSA user
     */
    UserApi.prototype.getSsaUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSsaUserRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a user
     */
    UserApi.prototype.getUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getUser.');
                        }
                        queryParameters = {};
                        if (requestParameters.app !== undefined) {
                            queryParameters['app'] = requestParameters.app;
                        }
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/{id}".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get a user
     */
    UserApi.prototype.getUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a user by logon id
     */
    UserApi.prototype.getUserByLogonIdRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.logonId === null || requestParameters.logonId === undefined) {
                            throw new runtime.RequiredError('logonId', 'Required parameter requestParameters.logonId was null or undefined when calling getUserByLogonId.');
                        }
                        queryParameters = {};
                        if (requestParameters.app !== undefined) {
                            queryParameters['app'] = requestParameters.app;
                        }
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/logonid/{logon_id}".replace("{" + "logon_id" + "}", encodeURIComponent(String(requestParameters.logonId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get a user by logon id
     */
    UserApi.prototype.getUserByLogonId = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserByLogonIdRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Indicate that a user has completed their myI9 training. Supported only for E-Verify.
     */
    UserApi.prototype.myI9TrainingCompletedRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling myI9TrainingCompleted.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/{id}/my-i9-training".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Indicate that a user has completed their myI9 training. Supported only for E-Verify.
     */
    UserApi.prototype.myI9TrainingCompleted = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.myI9TrainingCompletedRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Override a user\'s myI9 training-completed flag value. Supported only for E-Verify.
     */
    UserApi.prototype.overrideMyI9TrainingCompletedFlagRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling overrideMyI9TrainingCompletedFlag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/{id}/my-i9-training-override".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Override a user\'s myI9 training-completed flag value. Supported only for E-Verify.
     */
    UserApi.prototype.overrideMyI9TrainingCompletedFlag = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.overrideMyI9TrainingCompletedFlagRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Override a user\'s tutorial-completed flag value. Supported only for E-Verify.
     */
    UserApi.prototype.overrideTutorialCompletedFlagRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling overrideTutorialCompletedFlag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/{id}/tutorial-override".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Override a user\'s tutorial-completed flag value. Supported only for E-Verify.
     */
    UserApi.prototype.overrideTutorialCompletedFlag = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.overrideTutorialCompletedFlagRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * An endpoint which allows for a user\'s password to be reset via an API call.
     * Resets the password for the user
     */
    UserApi.prototype.resetPasswordByUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling resetPasswordByUser.');
                        }
                        if (requestParameters.resetPasswordBody === null || requestParameters.resetPasswordBody === undefined) {
                            throw new runtime.RequiredError('resetPasswordBody', 'Required parameter requestParameters.resetPasswordBody was null or undefined when calling resetPasswordByUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/{id}/password-reset".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ResetPasswordBodyToJSON(requestParameters.resetPasswordBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * An endpoint which allows for a user\'s password to be reset via an API call.
     * Resets the password for the user
     */
    UserApi.prototype.resetPasswordByUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resetPasswordByUserRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * provides a suggested legacy logonId
     */
    UserApi.prototype.suggestedLogonidRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.firstName === null || requestParameters.firstName === undefined) {
                            throw new runtime.RequiredError('firstName', 'Required parameter requestParameters.firstName was null or undefined when calling suggestedLogonid.');
                        }
                        if (requestParameters.lastName === null || requestParameters.lastName === undefined) {
                            throw new runtime.RequiredError('lastName', 'Required parameter requestParameters.lastName was null or undefined when calling suggestedLogonid.');
                        }
                        queryParameters = {};
                        if (requestParameters.firstName !== undefined) {
                            queryParameters['firstName'] = requestParameters.firstName;
                        }
                        if (requestParameters.lastName !== undefined) {
                            queryParameters['lastName'] = requestParameters.lastName;
                        }
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/suggested-logonid",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SuggestedLogonIdFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * provides a suggested legacy logonId
     */
    UserApi.prototype.suggestedLogonid = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.suggestedLogonidRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Indicate that a user has completed their tutorial.
     */
    UserApi.prototype.tutorialCompletedRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling tutorialCompleted.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/{id}/tutorial".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Indicate that a user has completed their tutorial.
     */
    UserApi.prototype.tutorialCompleted = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tutorialCompletedRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates password for the user, the id in the path must match the authenticated user that the Bearer token was issued for. >  Validation Error Codes:   * `PASSWORD_MINIMUM_NOT_EXCEEDED`   * `PASSWORD_INVALID`   * `PASSWORD_DUPLICATE`   * `GENERAL_VALIDATION`   * `PASSWORD_MISMATCH` > System Error Codes:   * `GENERAL_SYSTEM_ERROR`   * `PASSWORD_SYSTEM_ERROR`
     * Updates the password for the user
     */
    UserApi.prototype.updatePasswordByUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling updatePasswordByUser.');
                        }
                        if (requestParameters.updatePasswordBody === null || requestParameters.updatePasswordBody === undefined) {
                            throw new runtime.RequiredError('updatePasswordBody', 'Required parameter requestParameters.updatePasswordBody was null or undefined when calling updatePasswordByUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/{id}/password".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdatePasswordBodyToJSON(requestParameters.updatePasswordBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Updates password for the user, the id in the path must match the authenticated user that the Bearer token was issued for. >  Validation Error Codes:   * `PASSWORD_MINIMUM_NOT_EXCEEDED`   * `PASSWORD_INVALID`   * `PASSWORD_DUPLICATE`   * `GENERAL_VALIDATION`   * `PASSWORD_MISMATCH` > System Error Codes:   * `GENERAL_SYSTEM_ERROR`   * `PASSWORD_SYSTEM_ERROR`
     * Updates the password for the user
     */
    UserApi.prototype.updatePasswordByUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updatePasswordByUserRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * An endpoint to update attributes not supported by the other use case specific *PUT* endpoints
     */
    UserApi.prototype.updateUserAccountRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling updateUserAccount.');
                        }
                        if (requestParameters.updateUserBody === null || requestParameters.updateUserBody === undefined) {
                            throw new runtime.RequiredError('updateUserBody', 'Required parameter requestParameters.updateUserBody was null or undefined when calling updateUserAccount.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/{id}".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateUserBodyToJSON(requestParameters.updateUserBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * An endpoint to update attributes not supported by the other use case specific *PUT* endpoints
     */
    UserApi.prototype.updateUserAccount = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateUserAccountRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the profile of the requested user. >  Validation Error Codes:   * `GENERAL_VALIDATION_ERROR` > System Error Codes:   * `MESSAGING_SEND_FAILED`
     * Update a user profile
     */
    UserApi.prototype.updateUserProfileRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling updateUserProfile.');
                        }
                        if (requestParameters.person === null || requestParameters.person === undefined) {
                            throw new runtime.RequiredError('person', 'Required parameter requestParameters.person was null or undefined when calling updateUserProfile.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/{id}/profile".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.PersonToJSON(requestParameters.person),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the profile of the requested user. >  Validation Error Codes:   * `GENERAL_VALIDATION_ERROR` > System Error Codes:   * `MESSAGING_SEND_FAILED`
     * Update a user profile
     */
    UserApi.prototype.updateUserProfile = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateUserProfileRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates status for the requested user. >  Validation Error Codes:   * `GENERAL_VALIDATION_ERROR` > System Error Codes:   * `MESSAGING_SEND_FAILED`
     * Update a user\'s status
     */
    UserApi.prototype.updateUserStatusRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling updateUserStatus.');
                        }
                        if (requestParameters.userStatusRequest === null || requestParameters.userStatusRequest === undefined) {
                            throw new runtime.RequiredError('userStatusRequest', 'Required parameter requestParameters.userStatusRequest was null or undefined when calling updateUserStatus.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/{id}/status".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UserStatusRequestToJSON(requestParameters.userStatusRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates status for the requested user. >  Validation Error Codes:   * `GENERAL_VALIDATION_ERROR` > System Error Codes:   * `MESSAGING_SEND_FAILED`
     * Update a user\'s status
     */
    UserApi.prototype.updateUserStatus = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateUserStatusRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return UserApi;
}(runtime.BaseAPI));
exports.UserApi = UserApi;
